import { useLocalSearchParams } from 'expo-router'

import { FraternityReadyScreen } from '@/src/features/fraternity/ui/screens/FraternityReadyScreen'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

const CommunityJoinReadyRouterPage = () => {
  const searchParams = useLocalSearchParams()
  const { idSlug } = filterSearchParams<TIdSlugParam>(searchParams)

  if (!idSlug) return null

  return <FraternityReadyScreen idSlug={idSlug} searchParams={searchParams} />
}

export default CommunityJoinReadyRouterPage
